module.exports = "//cdn-staging.livechat-static.com/webapp/img/integrations/botengine-app-logo.png?3d20345504ed2d9697c6ea42527408da";